<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
      <b-form-input
          type="text"
          v-model="name"
          required
          minlength="2"
          maxlength="100"
          :pattern=fullNamePattern
          @invalid="$event.target.setCustomValidity($t('FormatInvalidName'))"
          @input.native="$event.target.setCustomValidity('')"
        />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("phoneNumber") }} <span class="text-danger">*</span></template>
      <b-form-input type="tel" v-model.trim="phone" required
                    :pattern="phonePattern" minlength="2" maxlength="50"
                    @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                    @input.native="$event.target.setCustomValidity('')" />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>Email <span class="text-danger">*</span></template>
      <b-form-input type="email" v-model.trim="email" required maxlength="100"></b-form-input>
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("address") }}</template>
      <b-form-textarea v-model="address" maxlength="255"></b-form-textarea>
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
    </div>

  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";

  import * as userService from "@/service/userService";
  import * as validationUtils from "@/service/validationUtils";


  @Component
  export default class EditPersonalInfoModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;

    name = "";
    phone = "";
    email = "";
    address = "";

    formErrorMsg = "";
    isSubmitting = false;


    mounted() {
      this.name = this.user.name;
      this.phone = this.user.phone;
      this.email = this.user.email;
      this.address = this.user.address;
    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    async submitForm() {
      this.formErrorMsg = "";

      this.name = this.name.trim();
      this.address = this.address?.trim() || '';
      
      if (!validationUtils.isEmail(this.email)) {
        this.formErrorMsg = this.$t("invalidEmail").toString();
        return;
      }

      const data = {
        id: this.userId,
        name: this.name,
        phone: this.phone,
        email: this.email,
        address: this.address
      };

      try {
        this.isSubmitting = true;
        await userService.updateUser(data);
        
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());
        this.user = await userService.getUserDetail();
        const delay = setTimeout(() => {
         
          clearTimeout(delay);
        }, 1000);
        this.$bvModal.hide(this.modalId);
        this.$emit('submitted');
      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

    @Emit() submitted() {
      this.$bvModal.hide(this.modalId);
    }

  }
</script>
